import TILES from '../../models/tiles';
import _ from 'lodash';

class TilesService {
  constructor($translate){
    this.$translate = $translate;
  }

  getTranslatedTiles(){
    var translatedTiles = _.map(TILES, this.translateLabel.bind(this));
    return translatedTiles;
  }

  translateLabel(tile) {
    tile.label = this.$translate.instant(tile.label);
    return tile;
  }
}

TilesService.$inject = ['$translate'];

export default TilesService;



// WEBPACK FOOTER //
// ./app/common/tiles/tiles.service.js